import { EngineerEmotionSmileIcon, Stub } from '@/shared';
import { OperationAlertProps } from './alert.types';

export const RoutemapCloseAlert = ({ productTechMapNumber, variant = 'product' }: OperationAlertProps) => {
	const variantName = {
		assembly: 'сборочной',
		preform: 'заготовительной',
		product: '',
		rubber: '',
	};

	return (
		<Stub
			icon={<EngineerEmotionSmileIcon />}
			header={`Маршрутная карта закрыта`}
			label={
				<p>
					Все работы по {variantName[variant]} маршрутной карте <strong>№{productTechMapNumber}</strong>{' '}
					завершены
				</p>
			}
		/>
	);
};
